import { useContext } from 'react'
import CookieContext from './context'

const useCookieConsent = () => {
  const ctx = useContext(CookieContext)

  if (!ctx) {
    throw new Error('useCookieConsent must be used within CookieProvider')
  }

  return ctx
}

export default useCookieConsent
